import { Suspense } from "react";
import { Navigate, Outlet } from "react-router";
import { SkipLink } from "@/components/a11y";
import { PageSkeleton } from "@/components/ui/page-skeleton";
import { useAuthStore } from "@/stores";

export function AuthLayout() {
	const { isAuthenticated } = useAuthStore();

	// If already authenticated, redirect to dashboard
	if (isAuthenticated) {
		return <Navigate to="/dashboard" replace />;
	}

	return (
		<>
			<SkipLink />
			<div className="min-h-svh flex items-center justify-center bg-muted/40">
				<main id="main-content" tabIndex={-1} data-testid="main-content">
					<Suspense fallback={<PageSkeleton />}>
						<Outlet />
					</Suspense>
				</main>
			</div>
		</>
	);
}
